import { render, staticRenderFns } from "./P6Activities.vue?vue&type=template&id=11262320&"
import script from "./P6Activities.vue?vue&type=script&lang=js&"
export * from "./P6Activities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports